import { State } from '../../types'

export function getDrawerIsOpen(state: State) {
	return state.Drawer.isOpen
}
